import { combineReducers } from "redux";
import listPayPalAccounts from "./listPayPalAccounts";
import showLoadingPage from "./showLoadingPage";
import dataSettings from "./dataSettings";
import dataStatistical from "./dataStatistical";
import listStore from "./listStore";
import filterIndicator from "./filterIndicator";
import showPlanDasboard from "./showPlanDasboard";
import commonSetting from "./commonSetting";

const myReducer = combineReducers({
  listPayPalAccounts,
  showLoadingPage,
  dataSettings,
  dataStatistical,
  listStore,
  filterIndicator,
  showPlanDasboard,
  commonSetting
});

export default myReducer;
